module.exports = __webpack_public_path__ + "static/media/icons_Bilan Neuromoteur 0 - 2 ans.2d5c76f6.svg";